export function removeNode(el) {
  var parent = el.parentNode;

  if (parent) {
    parent.removeChild(el);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/dom/node.js
// module id = 198
// module chunks = 0